import usePolicy from "hooks/usePolicy";
import ProjectsList from "../components/ProjectsList/ProjectsList";
import UtilsList from "../components/UtilsList/UtilsList";

import { UserPolices } from "constant";
import styles from "./main-page.module.scss";

const MainPage = () => {
  const { hasPolicy } = usePolicy();

  return (
    <div className={styles["main-page"]}>
      {hasPolicy(UserPolices.PROJECT_LIST) && <ProjectsList />}
      <UtilsList />
    </div>
  );
};

export default MainPage;
